import {
  GET_PZ_VALIDATION_REQUEST_BY_ID,
  REMOVE_PZ_VALIDATION_REQUEST_FROM_REQUESTS,
  SET_LOADER,
} from "./types";
import { apiService } from "../utils/serviceApi";
import { createSimpleAxiosErrorNotification, createSimpleSuccessNotification } from "../common/notifications/notification";

export const getPzValidationRequestById = (requestId) => async (dispatch) => {
  dispatch({ type: SET_LOADER, payload: true });
  apiService
    .get(`${process.env.REACT_APP_SERVICE_URL}/api/pz-validation/${requestId}`)
    .then((res) => {
      dispatch({ type: GET_PZ_VALIDATION_REQUEST_BY_ID, payload: res.data });
    })
    .catch((e) => {
      createSimpleAxiosErrorNotification(e);
    })
    .finally(() => {
      dispatch({ type: SET_LOADER, payload: false });
    });
};

export const approvePzValidationRequest = (id) => async (dispatch) => {
  dispatch({ type: SET_LOADER, payload: true });
  await apiService
    .put(`${process.env.REACT_APP_SERVICE_URL}/api/pz-validation/approve/${id}`)
    .then(() => {
      createSimpleSuccessNotification();
      dispatch({ type: REMOVE_PZ_VALIDATION_REQUEST_FROM_REQUESTS, payload: id });
    })
    .catch((e) => {
      createSimpleAxiosErrorNotification(e);
    })
    .finally(() => {
      dispatch({ type: SET_LOADER, payload: false });
    });
};

export const rejectPzValidationRequest = (id) => async (dispatch) => {
  dispatch({ type: SET_LOADER, payload: true });
  await apiService
    .put(`${process.env.REACT_APP_SERVICE_URL}/api/pz-validation/reject/${id}`)
    .then(() => {
      createSimpleSuccessNotification();
      dispatch({ type: REMOVE_PZ_VALIDATION_REQUEST_FROM_REQUESTS, payload: id });
    })
    .catch((e) => {
      createSimpleAxiosErrorNotification(e);
    })
    .finally(() => {
      dispatch({ type: SET_LOADER, payload: false });
    });
};

export const approveOnboardingTask = (requestId, taskType) => async (dispatch) => {
  dispatch({ type: SET_LOADER, payload: true });
  await apiService
    .put(`${process.env.REACT_APP_SERVICE_URL}/api/pz-validation/${requestId}/task/${taskType}/approve`)
    .then(() => {
      createSimpleSuccessNotification();
    })
    .catch((e) => {
      createSimpleAxiosErrorNotification(e);
    })
    .finally(() => {
      dispatch({ type: SET_LOADER, payload: false });
    });
};

export const rejectOnboardingTask = (requestId, taskType, reason) => async (dispatch) => {
  dispatch({ type: SET_LOADER, payload: true });
  await apiService
    .put(`${process.env.REACT_APP_SERVICE_URL}/api/pz-validation/${requestId}/task/${taskType}/reject`, { reason })
    .then(() => {
      createSimpleSuccessNotification();
    })
    .catch((e) => {
      createSimpleAxiosErrorNotification(e);
    })
    .finally(() => {
      dispatch({ type: SET_LOADER, payload: false });
    });
};
